<template>
    <div>
        <router-view/>
        <div class="bottom">
            <div style="height: 9vh;"></div>
            <mt-tabbar v-model="selected" class="container_bg" fixed>
                <mt-tab-item v-for="(item,index) in list" :key="index" v-if="item.isshow" :id="item.id" @click.prevent.native="topath(item.opera)" style='position:relative;'>
                    <i slot="icon" class="iconfont" :class="item.icon"></i>
                     {{item.name}}
                     <span id='unread' v-if='item.opera=="/message"' :style="unreadShow ? 'display:block' : 'display:none'"></span>
                </mt-tab-item>
            </mt-tabbar>
        </div>
    </div>
</template>
<script>
export default {
  data(){
      return{
          // selected:this.$store.state.selected
          selected:'',
          unread:'',
          unreadShow:true,
          progress:0,
          list:[
            {
              id:1,
              name:'我的工程',
              icon:'icon-icon-test',
              opera:'/main',
              isshow:true,
            },
            {
              id:2,
              name:'我的订单',
              icon:'icon-single',
              opera:'/order',
              isshow:true,
            },
            {
              id:3,
              name:'平台消息',
              icon:'icon-computer',
              opera:'/message',
              isshow:false,
            },
            {
              id:3,
              name:'我的合同',
              icon:'icon-computer',
              opera:'/contract',
              isshow:false,
            },
            {
              id:4,
              name:'个人中心',
              icon:'icon-wode',
              opera:'/account',
              isshow:true,
            },
          ],
          usertype:'',
      }
  },
  mounted:function () {
    if(localStorage['userinfo']){
      var obj = JSON.parse(localStorage['userinfo']);
      this.usertype = obj.usertype;
      this.selected = obj.selected_home;
      if(obj.usertype == 'customer'){
        this.list[3].isshow = true;
      }else{
        this.list[2].isshow = true;
        var that=this;
        this.$ajax.get(this.$$api.mobile.getMessageSum,{
        },function (res) {
          if(res.status ==200 ){
            if(res.data.success=='success'){
              var sum=res.data.detailMsg.data.sum;
              if(!sum){//如果没有未读消息
                that.unread='';
                that.unreadShow=false;
              }else{
                that.unread=sum;
                that.unreadShow=true;
              }
            }
          }
        });
      }
      console.log(obj.usertype);
    }else{
      this.$comm.goLogin();
    }
  },
  methods:{
      topath(val){
        var obj = JSON.parse(localStorage['userinfo'])||'';
        if(!obj)this.$comm.goLogin();
        obj.selected_home = this.selected;
        localStorage['userinfo'] = JSON.stringify(obj);
        if(val=='/order'){
          localStorage['serviceid'] = '';
        }
        this.$router.push({path: val});
        var that=this;
        //查询未读消息个数
        this.$ajax.get(this.$$api.mobile.getMessageSum,{
        },function (res) {
            if(res.status ==200 ){
              if(res.data.success=='success'){
                var sum=res.data.detailMsg.data.sum;
                if(!sum){
                  that.unread='';
                  that.unreadShow=false;
                }else{
                  that.unread=sum;
                  that.unreadShow=true;
                  //取消红点
                  if(val=='/message'){
                    that.unreadShow=false;
                  }
                }
              }
            }
        });
      }
  },
  watch:{
      selected(){
          // this.$store.state.selected=this.selected
      }
  }
}
</script>
<style>
    .container_bg{
        background:#f7f7f7;
    }
  .mint-tab-item .iconfont{
    font-size: 6vw !important;
  }
  #unread{
    position:absolute;top:4px;right:38%;margin-right:-5px;background:red;border-radius:50%; color:#fff;width:10px;height:10px;font-size:8px;line-height:10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue